import type {SVGProps} from 'react'
const SvgGetInvolvedMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 325 259" {...props}>
    <g mask="url(#get-involved-mobile_svg__mask0_1330_4486)">
      <g filter="url(#get-involved-mobile_svg__a)">
        <circle cx={93.687} cy={213.643} r={26.995} fill="#1A817C" />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M93.69 205.549a2.7 2.7 0 0 0-1.906.79 2.68 2.68 0 0 0-.79 1.907 2.697 2.697 0 1 0 2.697-2.697m-.515 1.452a1.35 1.35 0 0 1 1.862 1.245 1.345 1.345 0 0 1-2.3.952 1.34 1.34 0 0 1-.394-.952 1.35 1.35 0 0 1 .832-1.245M90.04 212.687a1.35 1.35 0 0 1 .951-.392h5.4a1.35 1.35 0 0 1 1.349 1.35v4.049c0 .425-.067.847-.197 1.251a4.052 4.052 0 0 1-6.93 1.377 4.05 4.05 0 0 1-.972-2.628v-4.059a1.35 1.35 0 0 1 .399-.948m6.35 5.007c0 .283-.044.565-.131.835a2.7 2.7 0 0 1-5.268-.836v-4.048h5.4zM99.765 206.896a2.023 2.023 0 1 0-.002 4.047 2.023 2.023 0 0 0 .001-4.047m-.478 1.547a.676.676 0 0 1 1.152.478c0 .179-.071.35-.197.477a.68.68 0 0 1-.955 0 .675.675 0 0 1 0-.955M103.139 213.645v3.374a3.37 3.37 0 0 1-1.487 2.798 3.38 3.38 0 0 1-3.151.332q.216-.421.356-.881a5.4 5.4 0 0 0 .233-1.574v-4.049c0-.493-.133-.953-.362-1.35h3.061a1.353 1.353 0 0 1 1.35 1.35m-2.242 5.054q-.269.18-.578.268.12-.62.12-1.273v-4.049h1.35v3.375a2.021 2.021 0 0 1-.892 1.679M89.048 207.489a2.023 2.023 0 1 0-2.862 2.86 2.023 2.023 0 0 0 2.862-2.86m-1.431.757a.677.677 0 0 1 .674.675.675.675 0 1 1-.674-.675M84.242 217.019v-3.374a1.353 1.353 0 0 1 1.35-1.35h3.061c-.23.397-.362.857-.362 1.35v4.049a5.4 5.4 0 0 0 .589 2.455 3.37 3.37 0 0 1-4.243-1.545 3.4 3.4 0 0 1-.395-1.585m2.82 1.948a2.01 2.01 0 0 1-1.233-.997 2 2 0 0 1-.237-.95v-3.375h1.35v4.049q0 .654.12 1.273"
        clipRule="evenodd"
      />
      <path
        stroke="#A6D9D7"
        d="M147.179 213.645c0 29.542-23.949 53.491-53.491 53.491s-53.49-23.949-53.49-53.491 23.948-53.491 53.49-53.491 53.491 23.949 53.491 53.491Z"
      />
      <path
        stroke="#A6D9D7"
        d="M174.175 213.646c0 44.451-36.035 80.486-80.486 80.486s-80.486-36.035-80.486-80.486S49.238 133.16 93.69 133.16s80.486 36.035 80.486 80.486Z"
      />
      <path
        stroke="#A6D9D7"
        d="M201.172 213.647c0 59.36-48.121 107.481-107.482 107.481S-13.79 273.007-13.79 213.647 34.33 106.166 93.69 106.166c59.361 0 107.482 48.121 107.482 107.481Z"
      />
      <g filter="url(#get-involved-mobile_svg__b)">
        <circle cx={241.484} cy={107.685} r={26.995} fill="#1A817C" />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M245.535 102.289a4.05 4.05 0 1 1-8.099 0 4.05 4.05 0 0 1 8.099 0m-1.35 0a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0M248.234 117.137a1.35 1.35 0 0 0 1.35-1.35 8.099 8.099 0 1 0-16.197 0c0 .745.604 1.35 1.349 1.35zm-6.749-8.099a6.75 6.75 0 0 0-6.749 6.749h13.498a6.75 6.75 0 0 0-6.749-6.749"
        clipRule="evenodd"
      />
      <path
        stroke="#A6D9D7"
        d="M294.976 107.687c0 29.542-23.949 53.491-53.491 53.491s-53.491-23.949-53.491-53.491 23.949-53.49 53.491-53.49 53.491 23.948 53.491 53.49Z"
      />
      <path
        stroke="#A6D9D7"
        d="M321.972 107.688c0 44.451-36.035 80.486-80.486 80.486S161 152.139 161 107.688s36.035-80.486 80.486-80.486 80.486 36.035 80.486 80.486Z"
      />
      <path
        stroke="#A6D9D7"
        d="M348.967 107.689c0 59.36-48.121 107.481-107.482 107.481s-107.481-48.121-107.481-107.481S182.125.208 241.485.208c59.361 0 107.482 48.12 107.482 107.481Z"
      />
    </g>
    <defs>
      <filter
        id="get-involved-mobile_svg__a"
        width={101.99}
        height={101.991}
        x={42.691}
        y={178.648}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={16} />
        <feGaussianBlur stdDeviation={12} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.12549 0 0 0 0 0.172549 0 0 0 0 0.34902 0 0 0 0.2 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1330_4486" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1330_4486" result="shape" />
      </filter>
      <filter
        id="get-involved-mobile_svg__b"
        width={101.99}
        height={101.991}
        x={190.488}
        y={72.69}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={16} />
        <feGaussianBlur stdDeviation={12} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.12549 0 0 0 0 0.172549 0 0 0 0 0.34902 0 0 0 0.2 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1330_4486" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1330_4486" result="shape" />
      </filter>
    </defs>
  </svg>
)
export default SvgGetInvolvedMobile
